import { RiArrowRightSLine } from '@remixicon/react'
import React from 'react'

export interface PaginationProps {
  currentPage: number
  totalItems: number
  itemsPerPage: number
  onNext: () => void
  onPrevious: () => void
}

/** The footer strip under a dashboard table: "1-10 of 42" plus two chevrons. */
export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onNext,
  onPrevious,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems)

  return (
    <div className="px-5 lg:px-7 py-4 flex justify-between items-center bg-white">
      <div className="text-dashboard-text text-[13px] font-normal leading-tight">
        {startIndex + 1}-{endIndex} of {totalItems}
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onPrevious}
          disabled={currentPage === 1}
          className="cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-70 transition-opacity"
          aria-label="Previous page"
        >
          <RiArrowRightSLine size={16} className="rotate-180" />
        </button>
        <button
          onClick={onNext}
          disabled={currentPage === totalPages}
          className="cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-70 transition-opacity"
          aria-label="Next page"
        >
          <RiArrowRightSLine size={16} />
        </button>
      </div>
    </div>
  )
}

export default Pagination
